import { Status } from '@/redux/reducers/common';
import { RootState } from '@/redux/store';
import React from 'react';
import { useSelector } from 'react-redux';
import StatusTag from '@/components/StatusTag';
import './index.scss';
import { PassportLogin } from '@jd/x-coreui';
const Login = () => {
  const common = useSelector((state: RootState) => state.common);
  const { steeringStatus, brakeStatus, screenStatus, cockpitNumber } = common;
  return (
    <div className="login-container">
      <div className="cockpit-box">
        <div className="qrcode-box">
          <div className="tip">远程驾驶员登录</div>
          <PassportLogin
            returnUrl={`${window.location.protocol}//${process.env.JDX_APP_JDX_COCKPIT}`}
          />
          <div className="tip">请用京东APP扫码登录</div>
        </div>

        <div className="status-box">
          <StatusTag
            enable={screenStatus === Status.ONLINE}
            enableText="屏幕状态已连接"
            disableText="屏幕状态未连接"
          />
          <StatusTag
            enable={steeringStatus === Status.ONLINE}
            enableText="方向盘已连接"
            disableText="方向盘未连接"
          />
          <StatusTag
            enable={brakeStatus === Status.ONLINE}
            enableText="脚刹已连接"
            disableText="脚刹未连接"
          />
        </div>
      </div>
      <div className="cockpit-number">驾舱编号：{cockpitNumber}</div>
    </div>
  );
};

export default React.memo(Login);
